<!-- ======= Patient Card (New) (Start) ======= -->
@if (newSidebar) {
  @if (!isDefaultsPage) {
    <app-es-patient-card [pat]="pat">
      <button
        card-add-btn
        class="es-patient-card__add-btn"
        [matTooltip]="'GUI.Tooltips.Open Patient Details' | translate | titlecase"
        (click)="openPatDetails()"
      >
        <mat-icon class="es-patient-card__add-icon">add</mat-icon>
      </button>
      <!-- spacer strip so card height stays consistent with exam sidebar -->
      <ng-container card-btn-strip>
        <div class="es-patient-card__btn" aria-hidden="true"></div>
        <div class="es-patient-card__btn" aria-hidden="true"></div>
      </ng-container>
    </app-es-patient-card>
  }
}
<!-- ======= Patient Card (New) (End) ======= -->

<!-- ======= Patient Info Panel (Legacy) (Start) ======= -->
@if (!newSidebar) {
  @if (!isDefaultsPage) {
    <div class="userPanel">
      <i class="userPanel-icon icon-female">
        <button class="btn-user_data" aria-label="user data" (click)="openPatDetails()"></button>
      </i>

      <div class="userPanel-userName">{{ pat.First }} {{ pat.Last }}</div>

      <dl class="l-table userPanel-userInfo">
        <div class="l-row">
          <dt class="l-td-m">
            {{ 'GUI.General.ID Number' | translate | titlecase }}
          </dt>
          <dd class="l-td-m">{{ pat.ID }}</dd>
        </div>
        <div class="l-row">
          <dt class="l-td-m">
            {{ 'GUI.General.Age' | translate | titlecase }}
          </dt>
          <dd class="l-td-m">{{ patService.getAgeMo() }}</dd>
        </div>
        <div class="l-row">
          <dt class="l-td-m">GA</dt>
          <dd class="l-td-m">{{ pat.getGA() }}</dd>
        </div>
        @if (login.getArchiveServer()) {
          <div class="l-row l-row--history">
            <dt class="l-td-m">History</dt>
            <dd class="l-td-m">
              <a target="_blank" [href]="login.getArchiveServer() + pat.ID">
                <img class="history-icon" src="../../assets/icons/oldarchive.svg" alt="History" />
              </a>
            </dd>
          </div>
        }
      </dl>
    </div>
  }

  <nav class="mainNav l-fg1 scroller"></nav>
}
<!-- ======= Patient Info Panel (Legacy) (End) ======= -->
